var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('vue-position-sticky',{directives:[{name:"resize",rawName:"v-resize:debounce",value:(_vm.onResize),expression:"onResize",arg:"debounce"}],ref:"mySticky",attrs:{"offsetTop":_vm.offsetTop,"offsetBottom":_vm.offsetBottom,"stickyClass":_vm.stickyClass},on:{"change":_vm.onChange}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }